import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/model_hub/analytics/analytics.py
export const MODEL_HUB_ANALYTICS_ACTIONS = {
  CLICKED_STRUCTURE_PREDICTION_RUN_ALL_MODELS: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'structure_prediction_click_run_all_models',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  MODEL_HUB_VIEWED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub_viewed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  MODEL_HUB_MODEL_CARD_CLICKED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub_model_card_clicked',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RUNS_TAB_VIEWED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.runs_tab.viewed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RUNS_TAB_FILTERED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.runs_tab.filtered',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RUNS_TAB_SORTED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.runs_tab.sorted',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RUNS_TAB_PAGE_CHANGED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.runs_tab.page_changed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  RUNS_TAB_PAGE_SIZE_CHANGED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.runs_tab.page_size_changed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  PREDICTION_JOBS_TAB_VIEWED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.prediction_jobs_tab.viewed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  INTERACTED_MODEL_HUB_PREVIEW_VIEWER: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.prediction_jobs_tab.interacted_preview_viewer',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DATA_FIRST_TAB_VIEWED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.data_first_tab.viewed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  DATA_FIRST_BATCH_SUBMITTED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.data_first.batch_submitted',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  STRUCTURE_TAB_BANNER_CLICKED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.structure_tab.bulk_predictions_banner_clicked',
    actionCategory: ACTION_CATEGORY.READ,
  },
  // Standalone signup wizard funnel. The account-creation event itself is emitted server-side
  // (MODEL_HUB_USER_SIGNED_UP in benchling/model_hub/views/signup.py); these are client-side
  // funnel telemetry, including the analytics-only "your work" survey answers.
  SIGNUP_VIEWED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.viewed',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SIGNUP_EMAIL_SUBMITTED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.email_submitted',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SIGNUP_GOOGLE_INITIATED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.google_initiated',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SIGNUP_GOOGLE_RETURNED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.google_returned',
    actionCategory: ACTION_CATEGORY.READ,
  },
  SIGNUP_CODE_VERIFIED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.code_verified',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SIGNUP_SURVEY_SUBMITTED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.survey_submitted',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
  SIGNUP_COMPLETED: {
    module: ANALYTICS_MODULE.MODEL_HUB,
    action: 'model_hub.signup.completed',
    actionCategory: ACTION_CATEGORY.WRITE,
  },
};

/**
 * Identifies where a prediction batch was triggered from.
 * Keep in sync with benchling/model_hub/constants.py PredictionBatchSource
 */
export const MODEL_RUN_SOURCE = {
  STRUCTURE_TAB: '3d_structure_tab',
  MODEL_HUB_UI: 'model_hub_ui',
  AI_CHAT: 'ai_chat',
  V3_API: 'v3_api',
} as const;

export type PredictionBatchSource = (typeof MODEL_RUN_SOURCE)[keyof typeof MODEL_RUN_SOURCE];
